import React from 'react';
import { ClockIcon, FileEditIcon, MapIcon, LayoutIcon } from 'lucide-react';
export function Benefits() {
  return <section className="py-20 bg-white" data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-3">
          {/* Ahorro de Tiempo */}
          <div className="flex flex-col items-center text-center group" data-id="element-4">
            <div className="bg-blue-600 p-4 rounded-2xl shadow-lg mb-6 transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3" data-id="element-5">
              <ClockIcon className="w-8 h-8 text-white" data-id="element-6" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-7">
              Save Hours of Prep Time
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-8">
              Stop spending evenings planning. Everything is ready to use
              directly in your classroom — just open and teach.
            </p>
          </div>

          {/* 100% Editable */}
          <div className="flex flex-col items-center text-center group" data-id="element-9">
            <div className="bg-amber-500 p-4 rounded-2xl shadow-lg mb-6 transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3" data-id="element-10">
              <FileEditIcon className="w-8 h-8 text-white" data-id="element-11" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-12">Print & Go</h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-13">
              Classroom-ready resources in a non-editable format—just download
              and print.
            </p>
          </div>

          {/* Diseño Curricular */}
          <div className="flex flex-col items-center text-center group" data-id="element-14">
            <div className="bg-red-600 p-4 rounded-2xl shadow-lg mb-6 transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3" data-id="element-15">
              <MapIcon className="w-8 h-8 text-white" data-id="element-16" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-17">
              Standards-Aligned
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-18">
              Content aligned with national arts education standards and Common
              Core learning objectives.
            </p>
          </div>

          {/* Versatilidad Total */}
          <div className="flex flex-col items-center text-center group" data-id="element-19">
            <div className="bg-purple-600 p-4 rounded-2xl shadow-lg mb-6 transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3" data-id="element-20">
              <LayoutIcon className="w-8 h-8 text-white" data-id="element-21" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-22">
              Incredibly Versatile
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-23">
              Perfect for public schools, private studios, after-school
              programs, and independent drama workshops.
            </p>
          </div>
        </div>
      </div>
    </section>;
}